import { Component } from '@angular/core';
import { NavParams, AlertController, ToastController, Events } from 'ionic-angular';
import { EventData } from '../../providers/event';
import { TranslateService } from '@ngx-translate/core';
import { Translate } from '../../providers/translate';

@Component({
  selector: 'event-message',
  templateUrl: 'event-message.html'
})
export class EventMessageComponent {

  obsToast: any;
  obsAlert: any;
  obsFooter: any;
  obsListener: any;
  messageFooter: any;
  messageToast: any;
  messageAlert: any;
  event: any;
  client: string;
  textTranslate: any;

  constructor(public params: NavParams, public alertCtrl: AlertController, public toastCtrl: ToastController, events: Events, public eventProvider: EventData, translate: Translate, public translateProvider: TranslateService) {
    translate.translateGroup(['Ok', 'Nuevo mensaje'])
    .then(result => {
      this.textTranslate = result;
    });

    this.event = this.params.get('event');
    this.client = this.params.get('client');

    this.obsListener = this.eventProvider.getListener(this.client, this.event.id, 'message').subscribe(stateModule => {

      if (stateModule.$value === true) {
        // Type Footer
        if (this.obsFooter) {
          this.obsFooter.unsubscribe();
        }
        // setTimeout(() => {
          this.obsFooter = eventProvider.getListMessages(this.client, this.event.id, 'Footer').subscribe((messages: any) => {
            if (messages) {
              this.messageFooter = messages[0];
              // messages.forEach(message => {
              //     this.messageFooter = message;
              // });
            } else {
              this.messageFooter = false;
            }
          });
        // }, 1000);

        // Type Alert
        if (this.obsAlert) {
          this.obsAlert.unsubscribe();
        }
        setTimeout(() => {
          this.obsAlert = eventProvider.getListMessages(this.client, this.event.id, 'Alert').subscribe((messages: any) => {
            messages.forEach(message => {
              if (this.messageAlert) {
                this.messageAlert.dismiss().then(() => {
                  setTimeout(() => {
                    this.createAlert(message);
                  }, 500);
                });
              } else {
                this.createAlert(message);
              }
            });
          });
        }, 1000);

        // Type Toast
        if (this.obsToast) {
          this.obsToast.unsubscribe();
        }
        setTimeout(() => {
          this.obsToast = eventProvider.getListMessages(this.client, this.event.id, 'Toast').subscribe((messages: any) => {
            messages.forEach(message => {
              if (this.messageToast) {
                this.messageToast.dismiss().then(() => {
                  setTimeout(() => {
                    this.createToast(message);
                  }, 1000);
                });
              } else {
                this.createToast(message);
              }
            });
          });
        }, 1000);
      }
    });

    // close de listener where logout user
    events.subscribe('client:logout', (r) => {
      this.closeListener();
    });
  }

  createToast(message) {
    this.messageToast = this.toastCtrl.create({
      message: message.message[this.translateProvider.getDefaultLang()],
      position: message.position,
      duration: message.duration,
      showCloseButton: true,
      closeButtonText: this.textTranslate['Ok']
    });

    this.messageToast.onDidDismiss(() => {
      this.messageToast = null;
    });

    this.messageToast.present();
  }

  createAlert(message) {
    this.messageAlert = this.alertCtrl.create({
      title: this.event.title,
      subTitle: this.textTranslate['Nuevo mensaje'],
      message: message.message[this.translateProvider.getDefaultLang()],
      buttons: [{
        text: this.textTranslate['Ok'],
        handler: () => {
          // TODO: Tracking
        }
      }]
    });

    this.messageAlert.onDidDismiss(() => {
      this.messageAlert = null;
    });

    this.messageAlert.present();
  }


  redirectFooter(message) {
    if (message.urlRedirect != '') {
      window.open(
        message.urlRedirect,
        '_blank'
      );
    }
  }
  closeListener() {
    if (this.obsListener) {
      console.log('Se eliminan los observables de Message');
      this.obsListener.unsubscribe();
    }
    if (this.obsAlert) {
      this.obsAlert.unsubscribe();
    }
    if (this.obsFooter) {
      this.obsFooter.unsubscribe();
    }
    if (this.obsToast) {
      this.obsToast.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/components/event-message/event-message.ts